
import { Component, Prop, Vue } from 'vue-property-decorator';
import service from '../../../services/app-http-client';
import { tenantModule } from '../../../store/modules/tenant/tenant.module';
import { PropSync } from 'vue-property-decorator';
import { Loading } from '@/modules/auth/store/auth.service';

@Component
export default class UpgradeButton extends Vue {
  @Prop() planName: string;
  @PropSync('isActive') isActiveSync: boolean;

  credits: { [key: string]: number } = { Small: 100, Medium: 500, Large: 1500 };

  getCredits(planName: string) {
    return this.credits[planName];
  }
  async confirmSubscription(planName: string) {
    const response = await this.$swal({
      icon: 'question',
      title: `${planName} package `,
      text: `Please confirm you are happy to proceed with a new subscription.
      The subscription will be billed to your account and a new billing cycle will start with ${this.getCredits(planName)} credits.`,
      position: 'center',
      showConfirmButton: true,
      confirmButtonText: 'Accept',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
    });
    if (response.isConfirmed) {
      this.upgradeSubscription(planName);
    }
  }
  @Loading
  async upgradeCall(planName: string) {
    return await service.put(`billing/update/${tenantModule.tenant.subscription.id}`, {
      planName,
    });
  }
  async upgradeSubscription(planName: string) {
    try {
      this.$emit('update');

      this.$router.replace({ path: '/organisation/account/checkout', query: { plan: planName } });
    } catch (error: any) {
      console.log(error);
    }
  }
}
